import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-634e5bf7")

_pushScopeId("data-v-634e5bf7")
const _hoisted_1 = { class: "dt-open-api-content inside-page-content" }
const _hoisted_2 = { class: "dt-open-api-personal-main" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_left_menu = _resolveComponent("left-menu")
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_left_menu, { menuList: _ctx.menuList }, null, 8, ["menuList"]),
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_router_view)
    ])
  ]))
})